export const CORPORATE_WEBSITE_URL = 'https://www.compliance.ai';

export const CORPORATE_WEBSITE_SIGN_UP_URL = `${CORPORATE_WEBSITE_URL}/?tryitnow=true`;
export const CORPORATE_WEBSITE_COMPARE_EDITIONS_URL = `${CORPORATE_WEBSITE_URL}/solution/#compare`;
export const CORPORATE_WEBSITE_REQUEST_AUTOTRANSLATION_URL = `${CORPORATE_WEBSITE_URL}/request-auto-translation`;
